<template>
    <header class="header">
        <div class="wrapper">
            <div class="col12 logo">
                <a v-if="partnerTitle && partnerTitle.length > 0">
                    <img src="/img/mamolico_logo.png" width="300" v-bind:alt="partnerTitle + 'まもりこ 直営ストア'" />
                    <strong
                        >{{ partnerTitle }}<br class="off-sp" />
                        まもりこ 直営ストア</strong
                    >
                </a>
                <a v-else>
                    <img src="/img/mamolico_logo.png" width="300" v-bind:alt="'まもりこ 直営ストア'" />
                    <strong>まもりこ 直営ストア</strong>
                </a>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    data: function () {
        return {
            partnerTitle: ""
        };
    },
    created() {
        this.partnerTitle = document.partnerTitle;
    }
};
</script>
